import ProductActions from "redux/actions/productActions";
import {sendData} from 'store/firebase/methods';
const { ActionTypes } = ProductActions;
const initialState = {
  data: [],
};



export default function reducer(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.ADD_PRODUCT: {
      const { product, collectionId } = action.payload;
      const newProducts = [...state.data, product];
      // localStorage.setItem(`selectedProducts`, JSON.stringify(newProducts));
      sendData(newProducts)
      return {
        ...state,
        data: newProducts,
      };
    }
    case ActionTypes.REMOVE_PRODUCT: {
      const { product, collectionId } = action.payload;
      const newProducts = state.data.filter((p) => p.id !== product.id);
      // localStorage.setItem(`selectedProducts`, JSON.stringify(newProducts));
      sendData(newProducts)

      return {
        ...state,
        data: newProducts,
      };
    }
    case ActionTypes.SET_PRODUCTS: {
      const { products, collectionId } = action.payload;
      const newProducts = [...state.data, products];
      // localStorage.setItem(`selectedProducts`, JSON.stringify(products));
      // sendData(newProducts)
      return {
        ...state,
        data: products,
      };
    }
    case ActionTypes.ADD_MULTIPLE_PRODUCTS: {
      const newProducts = [...state.data, ...action.payload];
      // localStorage.setItem(`selectedProducts`, JSON.stringify(newProducts));
      sendData(newProducts)

      return {
        ...state,
        data: newProducts,
      };
    }
    case ActionTypes.REMOVE_MULTIPLE_PRODUCTS: {
      const newProducts = action.payload;
      // localStorage.setItem(`selectedProducts`, JSON.stringify(newProducts));
      sendData(newProducts)

      return {
        ...state,
        data: newProducts,
      };
    }
    default:
      return state;
  }
}